import { MenuItem } from '@models/common.model';

export const MENU_ITEMS: MenuItem[] = [
    {
        name: 'statistic',
        title: `sidebar.statisticManagement`,
        icon: '/assets/icons/report-management.svg',
        children: [
            {
                title: `sidebar.chartOverview`,
                link: 'statistic/chart-overview',
                controller: 'Order',
                actionName: 'Order-StatisTicGetOrderChart7Day',
            },
            {
                title: `sidebar.chartOrder`,
                link: 'statistic/chart-order',
                controller: 'Order',
                actionName: 'Order-GetOrderPaymentChart',
            },
        ],
    },
    {
        name: 'order',
        title: `sidebar.orderManagement`,
        icon: '/assets/icons/order-management.svg',
        children: [
            {
                title: `sidebar.orderManagement`,
                link: '/order/order-management',
                controller: 'Order',
                actionName: 'Order-SearchListOrder',
            },
        ],
    },
    {
        name: 'booking',
        title: `sidebar.bookingManagement`,
        icon: '/assets/icons/booking-management.svg',
        children: [
            {
                title: `sidebar.bookingList`,
                link: '/booking/booking-manage',
                controller: 'Booking',
                actionName: 'Booking-SearchListBooking',
            },
        ],
    },
    {
        name: 'campaign',
        title: `sidebar.campaign`,
        icon: '/assets/icons/promotion-icon.svg',
        children: [
            {
                title: `sidebar.campaignList`,
                link: '/campaign/management',
                controller: 'Campaign',
                actionName: 'ManageCampaign',
            },
            {
                title: `sidebar.promotionCarrier`,
                link: '/campaign/carrier',
                controller: 'PromotionCarrier',
                actionName: 'ManagePromotionCarrier',
            },
            {
                title: `sidebar.promotionEmailReceive`,
                link: '/campaign/email',
                controller: 'EmailReceivePromotion',
                actionName: 'ManageEmailReceivePromotion',
            },
        ],
    },
    {
        name: 'user-management',
        title: `sidebar.userManagement`,
        icon: '/assets/icons/profile-3.svg',
        children: [
            {
                title: `sidebar.account`,
                link: '/user-management/manage-account',
                controller: 'User',
                actionName: 'UserManage',
            },
            {
                title: `sidebar.groupRole`,
                link: '/user-management/manage-group-role',
                controller: 'Permission',
                actionName: 'PermissionGroupRole',
            },
            {
                title: `sidebar.permission`,
                link: '/user-management/manage-permission',
                controller: 'Permission',
                actionName: 'PermissionGroupRoleRole',
            },
        ],
    },
    {
        name: 'report',
        title: `sidebar.reportManagement`,
        icon: '/assets/icons/report-management.svg',
        children: [
            {
                title: `sidebar.summaryReport`,
                link: 'report/summary',
                controller: 'Report',
                actionName: 'GeneralReport',
            },
        ],
    },
    {
        name: 'system-setting',
        title: `sidebar.systemSetting`,
        icon: '/assets/icons/setting.svg',
        children: [
            {
                title: `sidebar.cheepFlight`,
                link: 'system-setting/cheep-management',
                controller: 'CheepFlight',
                actionName: 'ManageCheepFlight',
            },
            {
                title: `sidebar.locationManagement`,
                link: 'system-setting/location-management',
                controller: 'LocationInfo',
                actionName: 'LocationInfoManage',
            },
            {
                title: `sidebar.favoriteLocationManagement`,
                link: 'system-setting/favorite-location-management',
                controller: 'FavoriteLocation',
                actionName: 'FavoriteLocationManage',
            },
            {
                title: `sidebar.partnerManagement`,
                link: 'system-setting/partner',
                controller: 'PartnerInfo',
                actionName: 'PartnerInfoManage',
            },
            {
                title: `sidebar.settingServiceFeeManagement`,
                link: 'system-setting/service-fee',
                controller: 'ServiceFee',
                actionName: 'ManageServiceFee',
            },
            {
                title: `sidebar.settingManagement`,
                link: 'system-setting/setting-management',
                controller: 'Setting',
                actionName: 'ManageSetting',
            },
        ],
    },
    {
        name: 'carrier-api',
        title: `sidebar.apiCarrierManagement`,
        icon: '/assets/icons/sort.svg',
        children: [
            {
                title: 'VietNam Airlines',
                link: 'carrier-api/VN',
                controller: 'CentralModule',
                actionName: 'ManageConfigModuleVN',
            },
            {
                title: 'Bamboo Airways',
                link: 'carrier-api/QH',
                controller: 'CentralModule',
                actionName: 'ManageConfigModuleQH',
            },
            {
                title: 'VietJet Air',
                link: 'carrier-api/VJ',
                controller: 'CentralModule',
                actionName: 'ManageConfigModuleVJ',
            },
            {
                title: 'Viettravel Airlines',
                link: 'carrier-api/VU',
                controller: 'CentralModule',
                actionName: 'ManageConfigModuleVU'
            },
            {
                title: 'Amadeus',
                link: 'carrier-api/1A',
                controller: 'CentralModule',
                actionName: 'ManageConfigModule1A',
            },
            {
                title: 'FLYONE',
                link: 'carrier-api/F1',
                controller: 'CentralModule',
                actionName: 'ManageConfigModuleF1',
            },
        ],
    },
    {
        name: 'system-log',
        title: 'Log hệ thống',
        icon: '/assets/icons/log-file.svg',
        expand: false,
        children: [
            {
                title: 'Booking log',
                link: 'system-log/booking',
                controller: 'LogSystem',
                actionName: 'BookingLog',
            },
        ],
    },
];
